import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import type { EABatchDetailVM } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";
import type { Nullable } from "@shared-kernel/core/types/nullable";
import { resetRetrieveEducationalAdvisorBatch, retrieveEducationalAdvisorBatch } from "./retrieve-educational-advisor-batch";

const initialState: RetrievalState<Nullable<EABatchDetailVM>> = { data: null, fetching: "idle" };

export const retrieveEducationalAdvisorBatchReducer = createReducer<RetrievalState<Nullable<EABatchDetailVM>>>(initialState, builder => {
  builder.addCase(retrieveEducationalAdvisorBatch.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveEducationalAdvisorBatch.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveEducationalAdvisorBatch.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
  builder.addCase(resetRetrieveEducationalAdvisorBatch, () => {
    return initialState;
  });
});
